import React, { useEffect, useRef, useState } from 'react'
import BlockTitle from '../common/BlockTitle'
import BlockImage from '../common/BlockImage'
// import classnames from 'classnames'
import { calculateStickyLimit, Sticky, Range } from '../common/Stiky'
// import ScrollElememt from '../../../components/ScrollElement'
import useRandomId from '../../../hooks/useRandomId'
import { modelImageUrl, modelMImageUrl } from '../../../assets'
import './style.scss'

type ConfidenceLimits = [Range, Range]

const imgUrl = window.innerWidth < 600 ? modelMImageUrl : modelImageUrl

const Model: React.FC = () => {
  const $containerRef = useRef<HTMLDivElement>(null)
  const [$container, set$container] = useState<HTMLDivElement | null>(null)
  const [$title, set$title] = useState<HTMLDivElement | null>(null)
  // const stickies = useMemo(() => {
  //   const ret: HTMLElement[] = []
  //   if ($title) {
  //     ret.push($title)
  //   }
  //   return ret
  // }, [$title])
  // const limits = useMemo<HighlightsLimits | null>
  const [limits, setLimits] = useState<ConfidenceLimits | null>(null)
  const titleOnceKey = useRandomId()
  const imageOnceKey = useRandomId()

  useEffect(() => {
    if (!$container || !$title) return
    if (limits) return
    setLimits(calculateStickyLimit($container, [$title]) as ConfidenceLimits)
  }, [limits, $container, $title])

  useEffect(() => {
    set$container($containerRef.current)
  }, [])

  return (
    <div id="model" ref={$containerRef}>
      <Sticky range={limits?.[0]} el={$title} zIndex={101}>
        <BlockTitle
          title="Business Model"
          getRef={(r) => set$title(r)}
          onceKey={titleOnceKey}
        />
      </Sticky>
      <div className="content">
        <BlockImage src={imgUrl} onceKey={imageOnceKey} />
      </div>
    </div>
  )
}

export default Model
